import { captureException } from '@sentry/nextjs';
import { setLocalStorageItem, getLocalStorageItem, Key } from 'src/utils/localStorage';

export const COMMUNITIES_DEFAULT_HIDE_IMAGE = [646, 195, 47, 803, 708, 949, 631, 656, 796, 1016, 756];

export const getShowCommunityImages = (communityId: number) => {
  try {
    let preferences = JSON.parse(getLocalStorageItem(Key.showImagesPreference) || '{}');
    if (typeof preferences === 'string') preferences = JSON.parse(preferences);
    const preference = preferences['communityId_' + communityId];
    return typeof preference !== 'undefined' ? preference : !COMMUNITIES_DEFAULT_HIDE_IMAGE.includes(communityId);
  } catch (ex) {
    captureException(ex);
  }
};

export const setShowCommunityImages = (communityId: number, preference: boolean) => {
  try {
    let preferences = JSON.parse(getLocalStorageItem(Key.showImagesPreference) || '{}');
    if (typeof preferences === 'string') preferences = JSON.parse(preferences);
    preferences['communityId_' + communityId] = preference;
    setLocalStorageItem(Key.showImagesPreference, JSON.stringify(preferences));
  } catch (ex) {
    captureException(ex);
  }
};
